<!--
 * @Author: Tahiti
 * @Date: 2025-10-21 15:03:16
 * @LastEditors: Tahiti
 * @LastEditTime: 2025-12-30 16:31:12
 * @Description: 
 * @FilePath: /weryai-web/components/Tool/ImageUploadMult.vue
-->
<template>
    <div class="mt-4">
        <label class="flex items-center text-white text-sm font-semibold mb-3">
            <span> {{ label || t('tools.imageLabel') }}</span>
            <span class="text-sub-title flex items-center text-xs ml-1">
                <span>(</span>
                <span
                    :class="
                        current_max_limit > maxLimitCount ? 'text-red-500' : ''
                    "
                >
                    {{ current_max_limit }}
                </span>
                <span>/</span>
                <span>
                    {{ maxLimitCount }}
                </span>
                <span>)</span>
            </span>
            <ClientOnly v-if="props?.show_tips">
                <el-popover
                    width="180"
                    :content="
                        tip_content || t('seo.imageToImage.page.upload_image')
                    "
                >
                    <template #reference>
                        <img
                            class="w-3 h-3 ml-2 cursor-help"
                            src="https://static.weryai.com/growth/image/4c8570087b6d87697059b93e7295b008.webp"
                            alt="info"
                        />
                    </template>
                </el-popover>
            </ClientOnly>
        </label>
        <div
            class="w-full flex items-center bg-[#1C1C20] rounded-[10px] p-[10px] min-h-[127px] border border-white/[.06]"
            :class="[current_max_limit ? 'justify-start' : 'justify-center']"
        >
            <el-dropdown
                v-if="!current_max_limit"
                class="flex items-center"
                :show-arrow="false"
                popper-style="popper"
                popper-class="generate-popper"
                trigger="click"
            >
                <div
                    class="min-h-[48px] text-[#666666] gap-2 group flex items-center justify-center border border-dashed border-white/20 rounded-[8px] p-[10px] cursor-pointer hover:text-white transition-all"
                >
                    <span class="i-smile-icon w-6 h-6"></span>
                    <span class="text-sm line-clamp-2">{{
                        t('characterToImg.clickAddCharacter')
                    }}</span>
                    <span class="i-dropdown-icon w-4 h-4"></span>
                </div>
                <template #dropdown>
                    <el-dropdown-menu class="custom">
                        <el-dropdown-item
                            v-for="item in chooseTypeEnums"
                            :key="item.name"
                            @click="handleChooseType(item.name)"
                        >
                            <span :class="item.icon" class="w-6 h-6"></span>
                            <span class="flex flex-col items-start">
                                <span class="text-[13px] leading-[1.5]">{{
                                    item.title
                                }}</span>
                                <span
                                    class="text-[11px] opacity-40 text-sub-title leading-[1.5]"
                                    >{{ item.desc }}</span
                                >
                            </span>
                        </el-dropdown-item>
                    </el-dropdown-menu>
                </template>
            </el-dropdown>

            <!-- Uploaded Images Grid -->
            <div
                v-if="current_max_limit"
                class="grid grid-cols-3 sm:grid-cols-6 md:grid-cols-8 lg:grid-cols-3 gap-[10px] flex-wrap rounded-[10px] items-center justify-start"
            >
                <div
                    v-for="item in preview_items"
                    :key="item.key"
                    class="flex-shrink-0 group aspect-square rounded-lg overflow-hidden flex items-center justify-center relative cursor-pointer"
                >
                    <div v-if="!item.loading">
                        <div
                            v-if="item?.name"
                            class="name-item absolute bottom-0 left-0 w-full text-center text-white text-xs p-1 truncate"
                        >
                            {{ item.name }}
                        </div>

                        <img
                            :src="item.src"
                            :alt="item.alt"
                            class="object-cover w-full h-full"
                            @load="markImageLoaded(item.src)"
                            @error="handleImgError(item.src)"
                        />

                        <!-- 图片还在加载时的遮罩 loading（只对 URL 图片生效） -->
                        <div
                            v-if="
                                typeof item.src === 'string' &&
                                !isImageLoaded(item.src)
                            "
                            class="absolute inset-0 z-[3] flex items-center justify-center bg-black/70"
                        >
                            <l-dot-spinner
                                v-if="isClient"
                                size="40"
                                speed="0.9"
                                color="var(--el-menu-active-color)"
                            ></l-dot-spinner>
                        </div>

                        <button
                            class="inline-flex rounded-full items-center justify-center whitespace-nowrap text-base font-medium ring-offset-background duration-200 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 hover:text-accent-foreground absolute z-[2] top-1 right-1 h-[22px] w-[22px] bg-black/80 text-white group-hover:opacity-100 transition-opacity"
                            @click.stop="handleDeletePreviewItem(item)"
                        >
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="12"
                                height="13"
                                viewBox="0 0 12 13"
                                fill="none"
                                class="w-3 h-3"
                            >
                                <path
                                    d="M9 3.68164L3 9.68164"
                                    stroke="white"
                                    stroke-width="2"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                />
                                <path
                                    d="M3 3.68164L9 9.68164"
                                    stroke="white"
                                    stroke-width="2"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                />
                            </svg>
                        </button>
                        <div
                            class="absolute !hidden w-6 h-6 bottom-1 right-1 bg-[#1D1D1D] text-white text-base px-1 rounded-full"
                        >
                            {{ item.order }}
                        </div>
                        <div
                            class="mask opacity-0 group-hover:opacity-100 absolute z-1 top-0 left-0 w-full h-full bg-black/30 rounded-lg transition-opacity duration-200"
                        ></div>
                    </div>
                    <div
                        v-else
                        class="w-20 h-20 flex items-center justify-center"
                    >
                        <l-dot-spinner
                            v-if="isClient"
                            size="40"
                            speed="0.9"
                            color="var(--el-menu-active-color)"
                        ></l-dot-spinner>
                    </div>
                </div>
                <!-- Add More Button -->
                <div
                    v-if="current_max_limit < maxLimitCount"
                    class="w-auto h-auto aspect-square rounded-lg bg-black/10 group cursor-pointer border border-dashed border-white/20 text-text-adad text-base flex flex-col items-center justify-center transition-colors add-image-btn hover:border-white/30 hover:text-white"
                >
                    <el-dropdown
                        class="flex items-center"
                        :show-arrow="false"
                        popper-style="popper"
                        popper-class="generate-popper"
                        trigger="click"
                    >
                        <div
                            class="min-h-[48px] text-[#666666] gap-2 group flex flex-col items-center justify-center rounded-[8px] p-[10px] cursor-pointer hover:text-white transition-all"
                        >
                            <span class="i-smile-icon w-6 h-6"></span>
                            <span class="text-sm text-center line-clamp-2">{{
                                t('characterToImg.continueAdd')
                            }}</span>
                        </div>
                        <template #dropdown>
                            <el-dropdown-menu class="custom">
                                <el-dropdown-item
                                    v-for="item in chooseTypeEnums"
                                    :key="item.name"
                                    @click="handleChooseType(item.name)"
                                >
                                    <span
                                        :class="item.icon"
                                        class="w-6 h-6"
                                    ></span>
                                    <span class="flex flex-col items-start">
                                        <span
                                            class="text-[13px] leading-[1.5]"
                                            >{{ item.title }}</span
                                        >
                                        <span
                                            class="text-[11px] opacity-40 text-sub-title leading-[1.5]"
                                            >{{ item.desc }}</span
                                        >
                                    </span>
                                </el-dropdown-item>
                            </el-dropdown-menu>
                        </template>
                    </el-dropdown>
                </div>
            </div>
        </div>
        <div class="text-sub-title text-xs flex gap-1 ml-1 items-center mt-1">
            <el-icon class="!text-sm"><Warning /></el-icon>
            {{ t('upload.errors.fileTooLarge', { maxSize: maxLimitCount }) }}
        </div>
    </div>
    <input
        ref="fileInput"
        type="file"
        multiple
        accept="image/*"
        @change="handleFileSelect"
        class="hidden"
    />

    <ui-choose-character-modal
        v-model:visible="character_visible"
        :max_limit="Math.max(0, maxLimitCount - (edit_image_list?.length || 0))"
        :edit_image_list="edit_image_list"
        :character_select_list="character_select_list"
        @change="handleUpdateCharacterSelectList"
    />
</template>
<script setup lang="ts">
import { computed, ref, onMounted, watch } from 'vue'
import { Warning } from '@element-plus/icons-vue'
import { useI18n } from '@/composables/useI18n'
import { debounce, noticeMessagePopup, getMaxImageSize } from '@/utils/common'
import { emitOpenImagePreview, showLoginModal } from '~/utils/emitter'
import axios from 'axios'
import { useUserStore } from '~/stores/user'


const props = withDefaults(
    defineProps<{
        show_tips?: boolean
        tip_content?: string
        label?: string
    }>(),
    {
        show_tips: false,
        tip_content: '',
        label: '',
    }
)

const { t, locale } = useI18n()

const character_visible = ref(false)

const uploadCount = ref(0)

const model = defineModel('model', {
    type: String,
    default: '',
})

const maxLimitCount = defineModel('upload_image_limit', {
    type: Number,
    default: 10,
})

const edit_image_list = defineModel('image_list', {
    type: Array<any>,
    default: () => [],
})

// 兼容：对外允许父组件接收“已选角色列表”（不影响旧用法）
const character_select_list_model = defineModel('character_select_list', {
    type: Array<any>,
    default: () => [],
})
// 用 computed(get/set) 做 v-model 代理，避免双向 watch 造成递归更新
const character_select_list = computed<Array<any>>({
    get() {
        return Array.isArray(character_select_list_model.value)
            ? character_select_list_model.value
            : []
    },
    set(val) {
        character_select_list_model.value = Array.isArray(val) ? val : []
    },
})

const handleUpdateCharacterSelectList = (val: Array<any>) => {
    character_select_list.value = val
}

const current_max_limit = computed(() => {
    return (
        (edit_image_list.value?.length || 0) +
        (character_select_list.value?.length || 0)
    )
})

const userStore = useUserStore()

const fileInput = ref<HTMLInputElement | null>(null)

/**
 * 图片“加载中”状态（仅针对已经拿到 URL 的图片）。
 * - key 使用图片 URL（字符串）
 * - value: true 表示浏览器已触发 img.onload（可以展示图片本体）
 */
const imageLoadedMap = ref<Record<string, boolean>>({})

const isImageLoaded = (image: any) => {
    if (typeof image !== 'string') return false
    return !!imageLoadedMap.value[image]
}

const markImageLoaded = (image: any) => {
    if (typeof image !== 'string') return
    imageLoadedMap.value[image] = true
}

const handleImgError = (image: any) => {
    // 出错也把 loading 关掉（避免遮罩一直转）
    markImageLoaded(image)
    onImageError()
}

// 当“上传图片列表/角色列表”变化时：为新 URL 初始化为“未加载”；并清理已不存在的 URL，避免内存增长
watch(
    () => [edit_image_list.value, character_select_list_model.value],
    ([imgList, charList]) => {
        const urlSet = new Set<string>()
        ;(imgList || []).forEach(item => {
            if (typeof item === 'string') urlSet.add(item)
        })
        ;(charList || []).forEach(item => {
            if (typeof item?.avatar === 'string') urlSet.add(item.avatar)
        })
        // init new
        urlSet.forEach(url => {
            if (imageLoadedMap.value[url] === undefined) {
                imageLoadedMap.value[url] = false
            }
        })
        // cleanup removed
        Object.keys(imageLoadedMap.value).forEach(url => {
            if (!urlSet.has(url)) delete imageLoadedMap.value[url]
        })
    },
    { deep: true, immediate: true }
)

type PreviewItem = {
    key: string
    kind: 'upload' | 'character' | 'upload_loading'
    src: string
    alt: string
    loading: boolean
    order: number
    // 用于删除：分别指向原数组的下标
    uploadIndex?: number
    characterIndex?: number
    name?: string
}

/**
 * 关键：预览展示顺序必须跟随“用户操作顺序”，而不是“先图片数组后角色数组”。
 * 做法：维护一条 previewOrder 时间线
 * - 上传开始：先插入 upload_loading 占位（有唯一 id）
 * - 上传完成：用同一个 id 的条目替换为 upload，位置不变
 * - 选择角色：检测新增角色，追加到时间线末尾
 * - 删除：从时间线移除对应条目
 */
type PreviewOrderEntry = {
    /** 时间线唯一 id，同时用于 upload_loading -> upload 的原位替换 */
    id: string
    kind: 'upload_loading' | 'upload' | 'character'
    /** upload: url；character: avatar（兜底用） */
    src?: string
    /** character: mate id（优先用于匹配） */
    characterKey?: string
}

const previewOrder = ref<PreviewOrderEntry[]>([])
let previewSeq = 0
const genPreviewId = (prefix: string) =>
    `${prefix}-${Date.now()}-${++previewSeq}`

const getCharacterKey = (c: any): string => {
    if (c?.id !== undefined && c?.id !== null) return String(c.id)
    if (typeof c?.avatar === 'string' && c.avatar) return c.avatar
    return ''
}

const initPreviewOrderIfEmpty = () => {
    if (previewOrder.value.length > 0)
        return // 先按当前已有数据初始化一条顺序（通常初始为空；若有回填，按当前数组顺序初始化）
    ;(edit_image_list.value || []).forEach((img: any) => {
        if (img && typeof img === 'object' && img.loading) {
            const id = img._previewId || genPreviewId('upload')
            // 给占位补一个稳定 id，便于后续替换/查找
            img._previewId = id
            previewOrder.value.push({ id, kind: 'upload_loading' })
            return
        }
        if (typeof img === 'string' && img) {
            previewOrder.value.push({
                id: genPreviewId('upload'),
                kind: 'upload',
                src: img,
            })
        }
    })
    ;(character_select_list.value || []).forEach((c: any) => {
        const key = getCharacterKey(c)
        if (!key) return
        previewOrder.value.push({
            id: genPreviewId('character'),
            kind: 'character',
            characterKey: key,
            src: typeof c?.avatar === 'string' ? c.avatar : undefined,
        })
    })
}

const prunePreviewOrder = () => {
    // upload urls 现存集合
    const uploadUrlSet = new Set<string>()
    const uploadLoadingIdSet = new Set<string>()
    ;(edit_image_list.value || []).forEach((img: any) => {
        if (typeof img === 'string' && img) uploadUrlSet.add(img)
        if (img && typeof img === 'object' && img.loading && img._previewId) {
            uploadLoadingIdSet.add(String(img._previewId))
        }
    })

    const characterKeySet = new Set<string>()
    ;(character_select_list.value || []).forEach((c: any) => {
        const key = getCharacterKey(c)
        if (key) characterKeySet.add(key)
    })

    // 先按“当前真实存在的数据”过滤掉无效条目
    const filtered = previewOrder.value.filter(e => {
        if (e.kind === 'upload_loading') return uploadLoadingIdSet.has(e.id)
        if (e.kind === 'upload') return !!e.src && uploadUrlSet.has(e.src)
        if (e.kind === 'character')
            return !!e.characterKey && characterKeySet.has(e.characterKey)
        return false
    })

    // 再做一次去重：角色不允许重复（同一个 characterKey 只保留第一次出现的位置）
    const seenCharacter = new Set<string>()
    previewOrder.value = filtered.filter(e => {
        if (e.kind !== 'character') return true
        const key = e.characterKey || ''
        if (!key) return false
        if (seenCharacter.has(key)) return false
        seenCharacter.add(key)
        return true
    })
}

// 监听外部回填/重置时：如果时间线为空则初始化；同时做一次修剪，避免残留
watch(
    () => [edit_image_list.value, character_select_list_model.value],
    () => {
        initPreviewOrderIfEmpty()
        prunePreviewOrder()
    },
    { deep: true, immediate: true }
)

// 监听角色列表变化：把“新增的角色”追加到时间线末尾（即用户操作顺序）
watch(
    () => character_select_list_model.value,
    (newList, oldList) => {
        const newKeys = (newList || []).map(getCharacterKey).filter(Boolean)
        const oldKeys = (oldList || []).map(getCharacterKey).filter(Boolean)
        const oldSet = new Set(oldKeys)

        // 只处理新增：新增追加到末尾
        const added = newKeys.filter(k => !oldSet.has(k))
        if (added.length === 0) return

        // 用当前列表找 avatar 作为兜底展示
        const avatarMap = new Map<string, string>()
        ;(newList || []).forEach((c: any) => {
            const k = getCharacterKey(c)
            if (!k) return
            if (typeof c?.avatar === 'string') avatarMap.set(k, c.avatar)
        })

        added.forEach(k => {
            // 关键：防止“初始化 watcher”与“新增 watcher”在同一轮同时写入造成重复
            const exists = previewOrder.value.some(
                e => e.kind === 'character' && e.characterKey === k
            )
            if (exists) return

            previewOrder.value.push({
                id: genPreviewId('character'),
                kind: 'character',
                characterKey: k,
                src: avatarMap.get(k),
            })
        })
    },
    { deep: true }
)

// UI：按时间线生成预览项（并回推当前下标用于删除）
const preview_items = computed<PreviewItem[]>(() => {
    const items: PreviewItem[] = []
    let order = 1

    for (const entry of previewOrder.value) {
        if (entry.kind === 'upload_loading') {
            const uploadIndex = (edit_image_list.value || []).findIndex(
                (img: any) =>
                    img &&
                    typeof img === 'object' &&
                    img.loading &&
                    img._previewId === entry.id
            )
            if (uploadIndex === -1) continue
            items.push({
                key: entry.id,
                kind: 'upload_loading',
                src: '',
                alt: 'loading',
                loading: true,
                order: order++,
                uploadIndex,
            })
            continue
        }

        if (entry.kind === 'upload') {
            const src = entry.src || ''
            const uploadIndex = (edit_image_list.value || []).findIndex(
                (img: any) => img === src
            )
            if (!src || uploadIndex === -1) continue
            items.push({
                key: entry.id,
                kind: 'upload',
                src,
                alt: String(uploadIndex),
                loading: false,
                order: order++,
                uploadIndex,
            })
            continue
        }

        if (entry.kind === 'character') {
            const key = entry.characterKey || ''
            if (!key) continue
            const characterIndex = (
                character_select_list.value || []
            ).findIndex((c: any) => getCharacterKey(c) === key)
            if (characterIndex === -1) continue
            const c = character_select_list.value[characterIndex]
            const src = c?.is_video ? c.avatarIcon : c.avatar
            if (!src) continue
            items.push({
                key: entry.id,
                kind: 'character',
                src: src,
                alt: String(c?.id ?? characterIndex),
                loading: false,
                order: order++,
                characterIndex,
                name: c?.name,
            })
        }
    }

    console.log('items', items)

    return items
})

const checkUploadMax = () => {
    if (uploadCount.value) {
        noticeMessagePopup(
            t('tools.pleaseWaitingUpload'),
            t('common.tip'),
            'warning',
            3000,
            ''
        )
        return false
    }

    if (edit_image_list.value.length > maxLimitCount.value - 1) {
        noticeMessagePopup(
            t('tools.maxUploadCount', { count: maxLimitCount.value }),
            t('common.tip'),
            'warning',
            3000,
            ''
        )

        return false
    }
    return true
}

const isLoggedIn = computed(() => userStore.isLoggedIn)

const triggerFileUpload = () => {
    if (!isLoggedIn.value) {
        showLoginModal()
        return
    }
    if (!checkUploadMax()) return

    fileInput.value?.click()
}

// drag upload
const handleFileDrop = (event: DragEvent) => {
    if (!isLoggedIn.value) {
        showLoginModal()
        return
    }
    if (!checkUploadMax()) return

    const files = event.dataTransfer?.files
    if (files) {
        const fileArray = Array.from(files)
        handleAutoBatchUpload(fileArray)
    }
}

const uploadFileList = ref<File[]>([])

// @ts-ignore
const config = useRuntimeConfig()
let token = ''
let language = ''

// upload image
const handleAutoBatchUpload = debounce(async (fileList: File[]) => {
    if (!fileList?.length) return
    // @ts-ignore

    // 校验文件大小（限制为10MB），过滤出符合要求的文件
    const validFiles: File[] = []
    const invalidFiles: { name: string; size: number }[] = []

    for (const file of fileList) {
        if (getMaxImageSize(file, 10)) {
            validFiles.push(file)
        } else {
            invalidFiles.push({ name: file.name, size: file.size })
        }
    }

    // 如果有文件超过限制，显示错误提示
    if (invalidFiles.length > 0) {
        const invalidFileNames = invalidFiles.map(f => f.name).join(', ')
        const errorMessage =
            invalidFiles.length === 1
                ? `${t('upload.errors.fileTooLarge', { maxSize: 10 })}: ${invalidFileNames}`
                : `${t('upload.errors.fileTooLarge', { maxSize: 10 })} (${invalidFiles.length} files): ${invalidFileNames}`

        noticeMessagePopup(errorMessage, t('common.tip'), 'error', 10000, '')
    }

    // 如果所有文件都超过限制，阻止上传
    if (validFiles.length === 0) {
        return
    }

    // 使用过滤后的有效文件列表
    const fileListToUpload = validFiles

    if (
        fileListToUpload.length + edit_image_list.value.length >
        maxLimitCount.value
    ) {
        noticeMessagePopup(
            t('tools.maxUploadCount', { count: maxLimitCount.value }),
            t('common.tip'),
            'warning',
            3000,
            ''
        )

        return
    }

    uploadFileList.value = fileListToUpload
    uploadCount.value = fileListToUpload.length

    // 关键：每个占位必须是“独立对象 + 独立 id”，否则无法按操作顺序原位替换
    const pendingIds: string[] = []
    for (let i = 0; i < uploadCount.value; i++) {
        const id = genPreviewId('upload')
        pendingIds.push(id)
        edit_image_list.value.push({ loading: true, _previewId: id })
        previewOrder.value.push({ id, kind: 'upload_loading' })
    }

    // set skeleton screen number
    const formData = new FormData()
    uploadFileList.value.forEach((fileObj: File) => {
        formData.append('files', fileObj)
    })
    try {
        // @ts-ignore
        if (import.meta.client) {
            token = localStorage.getItem('token') || ''
            // 请求语言跟随当前 URL 的 locale，而不是偏好/旧的 localStorage('language')
            language = locale.value || 'en'
        }
        const url = new URL(
            config.public.apiBase + '/api/v1/auth/s3/upload_images'
        )
        url.searchParams.append('app_key', config.public.appKey)

        const res = await axios.post(url.toString(), formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
                Authorization: token,
                'Accept-Language': language,
            },
        })

        const { data, status } = res.data
        if (status === 200) {
            // remove loading placeholder
            edit_image_list.value.splice(-uploadCount.value, uploadCount.value)
            // add actually uploaded image URL
            edit_image_list.value.push(...data?.object_url_list)

            // 用上传结果“原位替换”时间线里的占位项，保证顺序跟随用户操作
            const urls: string[] = data?.object_url_list || []
            pendingIds.forEach((id, idx) => {
                const url = urls[idx]
                const orderIndex = previewOrder.value.findIndex(
                    e => e.id === id && e.kind === 'upload_loading'
                )
                if (orderIndex === -1) return
                if (typeof url === 'string' && url) {
                    previewOrder.value[orderIndex] = {
                        id,
                        kind: 'upload',
                        src: url,
                    }
                } else {
                    // 没拿到对应 url，则移除占位
                    previewOrder.value.splice(orderIndex, 1)
                }
            })

            uploadCount.value = 0
        } else if ([1005, 4001, 4002].includes(status)) {
            showLoginModal()
        } else {
            edit_image_list.value.splice(-uploadCount.value, uploadCount.value)
            // 移除本次上传的占位
            previewOrder.value = previewOrder.value.filter(
                e => !pendingIds.includes(e.id)
            )
            uploadCount.value = 0
        }
    } catch (err) {
        // when upload failed, remove loading placeholder, restore original state
        edit_image_list.value.splice(-uploadCount.value, uploadCount.value)
        // 移除本次上传的占位
        previewOrder.value = previewOrder.value.filter(
            e => !pendingIds.includes(e.id)
        )
        uploadCount.value = 0
        console.error('upload failed:', err)
    } finally {
    }
}, 500)

// select file upload
const handleFileSelect = (event: Event) => {
    const target = event.target as HTMLInputElement
    const files = target.files as FileList

    if (edit_image_list.value.length > maxLimitCount.value - 1) {
        noticeMessagePopup(
            t('tools.maxUploadCount', { count: maxLimitCount.value }),
            t('common.tip'),
            'warning',
            3000,
            ''
        )
        // 重置 input 值，允许再次选择相同文件
        target.value = ''
        return false
    }
    // convert FileList to File[] array
    const fileArray = Array.from(files)
    // 直接调用 handleAutoBatchUpload，文件大小校验在 handleAutoBatchUpload 中统一处理
    handleAutoBatchUpload(fileArray)
    // 重置 input 值，允许再次选择相同文件
    target.value = ''
}

const onImageError = () => {
    noticeMessagePopup(
        t('tools.imageLoadFailed'),
        t('common.tip'),
        'warning',
        3000,
        ''
    )
    edit_image_list.value = []
    // 仅清理上传相关时间线，保留已选角色
    previewOrder.value = previewOrder.value.filter(e => e.kind === 'character')
}

// delete uploaded image
const deleteUploadedImage = (index: number) => {
    const img = edit_image_list.value?.[index]
    edit_image_list.value.splice(index, 1)
    // 同步移除时间线里对应的 upload（按 src 匹配，移除第一个）
    if (typeof img === 'string' && img) {
        const i = previewOrder.value.findIndex(
            e => e.kind === 'upload' && e.src === img
        )
        if (i > -1) previewOrder.value.splice(i, 1)
    }
}
// delete selected image
const deleteSelectedImage = (index: number) => {
    // 不要 splice 原地修改，使用重新赋值确保 v-model 更新与视图刷新
    const next = [...(character_select_list.value || [])]
    const removed = next[index]
    next.splice(index, 1)
    character_select_list.value = next
    // 同步移除时间线里对应的 character（按 characterKey 匹配）
    const key = getCharacterKey(removed)
    if (key) {
        const i = previewOrder.value.findIndex(
            e => e.kind === 'character' && e.characterKey === key
        )
        if (i > -1) previewOrder.value.splice(i, 1)
    }
}

// 统一删除入口：根据 item.kind 路由到对应的数组
const handleDeletePreviewItem = (item: PreviewItem) => {
    if (item.kind === 'upload' && typeof item.uploadIndex === 'number') {
        deleteUploadedImage(item.uploadIndex)
        return
    }
    if (item.kind === 'character' && typeof item.characterIndex === 'number') {
        deleteSelectedImage(item.characterIndex)
        return
    }
    // loading 项不允许删除（避免上传中断导致状态错乱）
}

const chooseTypeEnums = computed(() => {
    return [
        {
            name: 'character',
            icon: 'i-smile-icon',
            title: t('characterToImg.chooseCharacter'),
            desc: t('characterToImg.chooseCharacterDesc'),
        },
        {
            name: 'upload',
            icon: 'i-image-upload-icon',
            title: t('characterToImg.uploadImage'),
            desc: t('characterToImg.uploadImageDesc'),
        },
    ]
})

// 选择图片类型
const handleChooseType = (name: string) => {
    switch (name) {
        case 'character':
            character_visible.value = true
            break
        case 'upload':
            triggerFileUpload()
            break

        default:
            break
    }
}

const isClient = ref(false)

// 只在客户端注册 ldrs
onMounted(async () => {
    if (typeof window !== 'undefined') {
        try {
            const { dotSpinner } = await import('ldrs')
            dotSpinner.register()
            // 确保注册完成后再设置 isClient，避免组件在注册前渲染
            isClient.value = true
        } catch (error) {
            console.error('Failed to load ldrs:', error)
            // 即使加载失败也设置为 true，避免无限等待
            isClient.value = true
        }
    }
})
</script>
<style scoped lang="less">
:deep(.el-dropdown) {
    &:focus-visible {
        outline: none !important;
    }
}

.group {
    &:focus-visible {
        outline: none !important;
    }
}

:deep(.el-dropdown-menu__item) {
    padding: 6px 10px;
    border-radius: 6px;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    gap: 8px;
}

.custom {
    padding: 5px;
}

.name-item {
    height: 20px;
    border-radius: 0 0 8px 8px;
    background: rgba(0, 0, 0, 0.59);
}

</style>

<style>
.generate-popper {
    .el-dropdown-menu {
        border-radius: 10px!important;
    }
}
</style>
